// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1XU40","resendInfoText":"OnGoingPaymentBox_resendInfoText__3J7au"};